// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2Wz3d","rootCenter":"LoadMoreObserver_rootCenter__2C_cU","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2Szbo"};